import { useFullReleaseStrict } from "@/common/hooks_useFullRelease";
import { Typography } from "@mui/material";
import { get } from "lodash";
import { getCombinedConnections, isDcsvlyModule } from "./decisivelyModules";
import { useFormContext, useWatch } from "@imminently/decisively-ui/Form";
import SelectField from "@imminently/decisively-ui/SelectField";
import TextField from "@imminently/decisively-ui/TextField";

/**
 * Component designed to be injected into the AttributeCommunicationForm when the proxy method is selected.
 * - This component was largely copied from the AttributeIntegrationForm component but with certain features commented out and a Decisively module connection added in.
 */
export const AttributeCommunicationProxyForm = ({ scope, readOnly }: { scope: string; readOnly?: boolean }) => {
  const form = useFormContext<any>();
  const release = useFullReleaseStrict();

  const connections = getCombinedConnections(release.connections);
  // TODO: filtler by request or response
  // const requestMapping = release.mapping?.map(it => ({ key: it.name, value: it.id }));
  // const responseMapping = release.mapping?.map(it => ({ key: it.name, value: it.id }));

  const contentTypeOptions = [
    { value: "application/json", key: "JSON" },
    { value: "application/x-www-form-urlencoded", key: "Form URL Encoded" },
  ];
  // Find the selected connection's object
  const selectedConnValue = useWatch({ control: form.control, name: `${scope}.connection` });
  const selectedConnection = release.connections?.find((it) => it.id === selectedConnValue);
  const isDecisivelyModule = isDcsvlyModule(selectedConnValue);

  const methodOptions = [
    // { value: "get", key: "GET" },
    { value: "post", key: "POST" },
    { value: "put", key: "PUT" },
    { value: "patch", key: "PATCH" },
    // { value: "delete", key: "DELETE" },
  ];

  const scopedValue = (name: string) => `${scope}.${name}`;

  return (
    <div className="flex flex-col gap-4">
      {/* <TextField fullWidth label="Title" required name={scopedValue("title")} /> */}
      <SelectField
        label="Connection"
        required
        name={scopedValue("connection")}
        options={(connections || []).map((it) => ({ value: it.value, label: it.key }))}
        disabled={readOnly}
        fullWidth
      />
      {isDecisivelyModule ? null : (
        <>
          {/* Show Base URL from selected connection */}
          {selectedConnection?.url && (
            <Typography
              variant="subtitle2"
              color="textSecondary"
            >
              Base URL: <strong>{selectedConnection.url}</strong>
            </Typography>
          )}
          {/* Path Input Field */}
          <TextField
            required
            label="Path (relative to Base URL)"
            name={scopedValue("path")}
            disabled={readOnly}
            fullWidth
          />
          {/* General API Settings */}
          <SelectField
            label="HTTP Method"
            required
            name={scopedValue("restMethod")}
            options={methodOptions.map((it) => ({ value: it.value, label: it.key }))}
            disabled={readOnly}
            fullWidth
          />
          <SelectField
            label="Content Type"
            required
            name={scopedValue("contentType")}
            options={contentTypeOptions.map((it) => ({ value: it.value, label: it.key }))}
            disabled={readOnly}
            fullWidth
          />
          {/* Query */}
          <TextField
            label="Query Parameters"
            name={scopedValue("query")}
            disabled={readOnly}
            fullWidth
          />
        </>
      )}

      {/* Query & Mapping */}

      {/* <SelectField label="Request Mapping" name={scopedValue("requestMapping")} options={requestMapping || []} fullWidth />
      <SelectField label="Response Mapping" name={scopedValue("responseMapping")} options={responseMapping || []} fullWidth /> */}

      {/* Retry & Security Settings */}
      <TextField
        type="number"
        label="Retry Attempts"
        name={scopedValue("retryAttempts")}
        disabled={readOnly}
        fullWidth
      />
    </div>
  );
};
